import styled from "styled-components";

export const FirmaDigitalContainer = styled.div`
  .firma-box {
    padding-bottom: 24px;
    border-radius: 24px;
    margin: 0 16px 0 16px;
    
  }

  .firma-box-pad {
    min-width: 600px;
    /* height: 200px; */
    width: max-content;
    display: block;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 10px;
    @media (max-width: 600px) {
      min-width: 320px;
    }
  }

  .sigCanvas {
    border-radius: 10px;
    width: 600px;
    height: 230px;
    border: var(--color-latex30) 4px solid;
  }

  .firma-box-cargandoPad-fondo {
    position: absolute; 
    top: 0;
    left: 0;
    width: 100%;
    height:100%;
    /* background-color: red; */
  }

  .firma-enviando {
    border-radius: 10px;
    width: 100%;
    height: 230px;
  }

  .firma-enviando-texto {
    display: block;
    text-align: center;
  }

  .firma-box-botones {
    width: 100%;
    display: flex;
    /* flex-wrap: wrap; */
    justify-content: center;
    align-items: center;
    gap: 22px;
  }

  .btn-firma {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 34%;
    height: 38px;
    box-shadow: 0px 90.2394px 72.1915px rgba(0, 0, 0, 0.07),
      0px 37.6999px 30.1599px rgba(0, 0, 0, 0.0503198),
      0px 20.1562px 16.1249px rgba(0, 0, 0, 0.0417275),
      0px 11.2994px 9.0395px rgba(0, 0, 0, 0.035),
      0px 6.00101px 4.80081px rgba(0, 0, 0, 0.0282725),
      0px 2.49716px 1.99772px rgba(0, 0, 0, 0.0196802);
    border-radius: 6px;
    margin-top: 12px;
    cursor: pointer;
  }
  .bgc-secondary {
    background-color: hsla(11, 100%, 70%, 1);
  }

  @media (max-width: 600px) {
    .firma-box-botones {
      margin-top: 8px;
      display: flex;
      gap: 20px;
    }
    .btn-firma {
      width: 100%;
      min-width: 150px;
    }
    .sigCanvas {
      border-radius: 10px;
      width: 320px;
      height: 200px;
    }
    .firma-box-cargandoPad {
      width: 320px;
      height: 204px;
    }
  }
`;
